import { Fragment, FunctionalComponent, h } from 'preact';
import Icon from '../../../common/Icon/Icon';
import { Properties } from '../../../common';
import { Row } from '../../../common/Layout/Layout';
import { WithStyles, withStyles } from '../../../style';
import * as styles from './Notification.scss';
import * as appStyles from '../../../assets/global.scss';
import { Indexed } from '../../../utils';

export enum Severity {
  INFO = 'info',
  ERROR = 'error',
}

const ariaLivePoliteness: Indexed<string> = {
  info: 'polite',
  error: 'assertive',
};

export interface NotificationProps extends Properties {
  open: boolean;
  severity: Severity;
  expanded?: boolean;
  award?: boolean;
}

type NotificationRenderProps = NotificationProps & WithStyles;

const Notification: FunctionalComponent<NotificationProps> = withStyles(
  styles,
  appStyles
)(({ tx, open, severity, expanded, award, children, ...props }: NotificationRenderProps) => {
  const isAward = award || false;
  return (
    <Row
      vCenter={!expanded}
      class={tx(props.class, 'notification', 'contentArea', 'nordic-blue-900-text pr-medium-x rounded-medium', {
        'open mr-xxsmall-t': open,
        expanded,
      })}
    >
      {open && (
        <Fragment>
          {!isAward && (
            <div class={tx(`ps-small-r ps-xsmall-y flex--self-start`)}>
              <Icon iconName="info-block" class={tx(`ir-small`)} />
            </div>
          )}
          <div class="nordic-blue-900-text font-body-1 ps-xsmall-y fill" aria-live={ariaLivePoliteness[severity]}>
            {children}
          </div>
        </Fragment>
      )}
    </Row>
  );
});

export default Notification;
